export function ifOneThenTrue(value: string | undefined): boolean {
  if (value === undefined) {
    return false;
  }
  const number = parseInt(value);
  return value ? number === 1 : false;
}
